import Vue from "vue"
import VueFormulate from "@braid/vue-formulate"
import { es } from "@braid/vue-formulate-i18n"

//registro nuevos inputs
import InputPrice from "./InputPrice"
Vue.component("InputPrice", InputPrice)

// import InputAutocomplete from './InputAutocomplete'
// Vue.component('InputAutocomplete', InputAutocomplete)

// import InputFile from './InputFile'
// Vue.component('InputFile', InputFile)
// import InputTags from './InputTags'
// Vue.component('InputTags', InputTags)
import InputDate from "./InputDate"
Vue.component("InputDate", InputDate)
// import InputWysiwyg from './InputWysiwyg'
// Vue.component('InputWysiwyg', InputWysiwyg)
import Phone from "./InputPhone"
Vue.component("Phone", Phone)
import InputIdentification from "./InputIdentification"
Vue.component("InputIdentification", InputIdentification)
// import InputLatLng from './InputLatLng'
// Vue.component('InputLatLng', InputLatLng)
// import InputSlug from './InputSlug'
// Vue.component('InputSlug', InputSlug)
import InputSelect from "./InputSelect"
Vue.component("InputSelect", InputSelect)

import { customRules, customMessages } from "./customRules"

Vue.use(VueFormulate, {
	plugins: [es],
	locale: "es",
	library: {
		// autocomplete: { classification: 'text', component: 'InputAutocomplete' },
		price: { classification: "text", component: "InputPrice" },
		// file: { classification: 'text', component: 'InputFile' },
		// tags: { classification: 'text', component: 'InputTags' },
		date: { classification: "date", component: "InputDate" },
		// wysiwyg: { classification: 'wysiwyg', component: 'InputWysiwyg' },
		phone: { classification: "phone", component: "Phone" },
		identification: { classification: "text", component: "InputIdentification" },
		// latlng: { classification: 'text', component: 'InputLatLng' },
		// slug: { classification: 'text', component: 'InputSlug' },
		selectSearch: { classification: "text", component: "InputSelect" }
	},
	rules: {
		...customRules
	},
	locales: { ...customMessages }
})
import "@braid/vue-formulate/themes/snow/snow.scss"
